export function useStatics() {
    const brandName ='The Real Devs Pro';
    const brandWebSite ='www.therealdevs.pro';
    // ------------------------------------------------------------------
    // 1. ETNIAS Y NACIONALIDADES
    // ------------------------------------------------------------------
    const ethnicities = [
        { value: 1, text: 'Mestizo' },
        { value: 2, text: 'Indígena' },
        { value: 3, text: 'Afrodescendiente' },
        { value: 4, text: 'Caucásico/Blanco' },
        { value: 5, text: 'Otro' },
    ];

    const nationalities = [
        { value: 1, text: 'Nacional' },
        { value: 2, text: 'Extranjero' },
    ];

    // ------------------------------------------------------------------
    // 2. DEPARTAMENTOS (Lista completa)
    // ------------------------------------------------------------------
    const departments = [
        { value: 1, text: 'Managua' },
        { value: 2, text: 'León' },
        { value: 3, text: 'Chinandega' },
        { value: 4, text: 'Masaya' },
        { value: 5, text: 'Granada' },
        { value: 6, text: 'Estelí' },
        { value: 7, text: 'Matagalpa' },
        { value: 8, text: 'Chontales' },
        { value: 9, text: 'Rivas' },
        { value: 10, text: 'Boaco' },
        { value: 11, text: 'Carazo' },
        { value: 12, text: 'Jinotega' },
        { value: 13, text: 'Madriz' },
        { value: 14, text: 'Nueva Segovia' },
        { value: 15, text: 'Río San Juan' },
        { value: 16, text: 'RAAN (Bilwi – Caribe Norte)' },
        { value: 17, text: 'RAAS (Bluefields – Caribe Sur)' },
    ];

    // ------------------------------------------------------------------
    // 3. MUNICIPIOS (expandidos y completos)
    // ------------------------------------------------------------------
    const cities = [
        // Managua (1)
        { value: 101, text: 'Managua (Ciudad)', department_id: 1 },
        { value: 102, text: 'Ciudad Sandino', department_id: 1 },
        { value: 103, text: 'Tipitapa', department_id: 1 },
        { value: 104, text: 'Ticuantepe', department_id: 1 },
        { value: 105, text: 'Mateare', department_id: 1 },
        { value: 106, text: 'San Francisco Libre', department_id: 1 },

        // León (2)
        { value: 201, text: 'León (Ciudad)', department_id: 2 },
        { value: 202, text: 'Nagarote', department_id: 2 },
        { value: 203, text: 'La Paz Centro', department_id: 2 },
        { value: 204, text: 'Quezalguaque', department_id: 2 },
        { value: 205, text: 'Telica', department_id: 2 },
        { value: 206, text: 'El Jicaral', department_id: 2 },

        // Chinandega (3)
        { value: 301, text: 'Chinandega (Ciudad)', department_id: 3 },
        { value: 302, text: 'El Viejo', department_id: 3 },
        { value: 303, text: 'Chichigalpa', department_id: 3 },
        { value: 304, text: 'Corinto', department_id: 3 },
        { value: 305, text: 'Posoltega', department_id: 3 },
        { value: 306, text: 'Somotillo', department_id: 3 },
        { value: 307, text: 'Villanueva', department_id: 3 },

        // Masaya (4)
        { value: 401, text: 'Masaya (Ciudad)', department_id: 4 },
        { value: 402, text: 'Nindirí', department_id: 4 },
        { value: 403, text: 'Niquinohomo', department_id: 4 },
        { value: 404, text: 'Masatepe', department_id: 4 },
        { value: 405, text: 'Tisma', department_id: 4 },
        { value: 406, text: 'Catarina', department_id: 4 },

        // Granada (5)
        { value: 501, text: 'Granada (Ciudad)', department_id: 5 },
        { value: 502, text: 'Nandaime', department_id: 5 },
        { value: 503, text: 'Diriomo', department_id: 5 },
        { value: 504, text: 'Diriá', department_id: 5 },

        // Estelí (6)
        { value: 601, text: 'Estelí (Ciudad)', department_id: 6 },
        { value: 602, text: 'La Trinidad', department_id: 6 },
        { value: 603, text: 'Pueblo Nuevo', department_id: 6 },
        { value: 604, text: 'Condega', department_id: 6 },

        // Matagalpa (7)
        { value: 701, text: 'Matagalpa (Ciudad)', department_id: 7 },
        { value: 702, text: 'Sébaco', department_id: 7 },
        { value: 703, text: 'San Ramón', department_id: 7 },
        { value: 704, text: 'Río Blanco', department_id: 7 },
        { value: 705, text: 'Ciudad Darío', department_id: 7 },

        // Chontales (8)
        { value: 801, text: 'Juigalpa', department_id: 8 },
        { value: 802, text: 'Acoyapa', department_id: 8 },
        { value: 803, text: 'Santo Tomás', department_id: 8 },
        { value: 804, text: 'Villa Sandino', department_id: 8 },

        // Rivas (9)
        { value: 901, text: 'Rivas (Ciudad)', department_id: 9 },
        { value: 902, text: 'San Juan del Sur', department_id: 9 },
        { value: 903, text: 'Tola', department_id: 9 },
        { value: 904, text: 'Potosí', department_id: 9 },

        // Boaco (10)
        { value: 1001, text: 'Boaco (Ciudad)', department_id: 10 },
        { value: 1002, text: 'San Lorenzo', department_id: 10 },
        { value: 1003, text: 'Camoapa', department_id: 10 },

        // Carazo (11)
        { value: 1101, text: 'Jinotepe', department_id: 11 },
        { value: 1102, text: 'Diriamba', department_id: 11 },
        { value: 1103, text: 'San Marcos', department_id: 11 },
        { value: 1104, text: 'La Paz (Carazo)', department_id: 11 },

        // Jinotega (12)
        { value: 1201, text: 'Jinotega (Ciudad)', department_id: 12 },
        { value: 1202, text: 'San Rafael del Norte', department_id: 12 },
        { value: 1203, text: 'La Concordia', department_id: 12 },
        { value: 1204, text: 'Wiwilí (Jinotega)', department_id: 12 },

        // Madriz (13)
        { value: 1301, text: 'Somoto', department_id: 13 },
        { value: 1302, text: 'Totogalpa', department_id: 13 },
        { value: 1303, text: 'San Lucas', department_id: 13 },
        { value: 1304, text: 'Telpaneca', department_id: 13 },

        // Nueva Segovia (14)
        { value: 1401, text: 'Ocotal', department_id: 14 },
        { value: 1402, text: 'Jalapa', department_id: 14 },
        { value: 1403, text: 'Dipilto', department_id: 14 },
        { value: 1404, text: 'Mozonte', department_id: 14 },

        // Río San Juan (15)
        { value: 1501, text: 'San Carlos', department_id: 15 },
        { value: 1502, text: 'El Castillo', department_id: 15 },
        { value: 1503, text: 'Morrito', department_id: 15 },

        // RAAN / Caribe Norte (16)
        { value: 1601, text: 'Bilwi (Puerto Cabezas)', department_id: 16 },
        { value: 1602, text: 'Waspam', department_id: 16 },
        { value: 1603, text: 'Siuna', department_id: 16 },
        { value: 1604, text: 'Rosita', department_id: 16 },
        { value: 1605, text: 'Bonanza', department_id: 16 },

        // RAAS / Caribe Sur (17)
        { value: 1701, text: 'Bluefields', department_id: 17 },
        { value: 1702, text: 'El Rama', department_id: 17 },
        { value: 1703, text: 'Laguna de Perlas', department_id: 17 },
        { value: 1704, text: 'Kukra Hill', department_id: 17 },
    ];

    return {
        ethnicities,
        nationalities,
        departments,
        cities,
        brandName,
        brandWebSite
    };
}